<template>
  <div v-if="show" class="work-experience-dialog" :class="hasResumeView ? 'has-resume-view' : ''">
    <div class="workExperience-list-editor">
      <template v-for="(partTimeExperience, index) in partTimeExperienceList">
        <div class="workExperience-table" :class="!partTimeExperience.showEdit && 'show-table'" :key="`partTimeExperience_${index}`">
          <div class="head">
            <div class="title" @click="editorPartTime(partTimeExperience, index)">{{ `${$t(`${i18nPrefix}.title.partTimeExperience`)} ${index + 1}` }}</div>
            <div class="fold-btn" :class="partTimeExperience.showEdit ? 'rotated-icon' : ''" @click="editorPartTime(partTimeExperience, index)">
              <i class="iconfont icondown"></i>
            </div>
            <el-popconfirm
              :confirm-button-text="$t('common.btn.confirm')"
              :cancel-button-text="$t('common.btn.cancel')"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('common.message.confirmDelete')"
              @confirm="deletePartTime(partTimeExperience, index)"
            >
              <template #reference>
                <div class="delete-btn">
                  <i class="el-icon-close"></i>
                </div>
              </template>
            </el-popconfirm>
          </div>
          <div class="content">
            <el-table
              v-if="!partTimeExperience.showEdit"
              stripe
              row-key="_vid"
              :show-header="false"
              :data="[partTimeExperience]"
              :row-class-name="getRowClass"
            >
              <el-table-column class-name="start-date" prop="startDate" :width="hasResumeView ? '90px' : '100px'" :formatter="formatDate"></el-table-column>
              <el-table-column prop="endDate" :width="hasResumeView ? '90px' : '100px'" :formatter="formatDate"></el-table-column>
              <el-table-column prop="companyName"></el-table-column>
              <el-table-column prop="jobTitle"></el-table-column>
            </el-table>
            <WorkExperience
              v-else
              class="workExperience-editor editor"
              :ref="`partTimeEdit_${index}`"
              :workExperience="partTimeExperience"
              :jobFamilyList="jobFamilyList"
              :countryList="countryList"
              :provinceList="partTimeExperience.provinceList"
              :cityList="partTimeExperience.cityList"
              :industryList="industryList"
              :currencyList="currencyList"
              :salaryList="salaryList"
              :isMiniResume="isMiniResume"
              :isCandidate="isCandidate"
              @country-change="handleCountryChange($event, partTimeExperience)"
              @province-change="handleProvinceChange($event, partTimeExperience)"
            />
          </div>
        </div>
      </template>
      <div class="add-btn-group">
        <el-button
          class="add-btn part-time-btn"
          type="text"
          icon="iconfont iconjia"
          @click="handleAddPartTime"
        >
          {{ this.$t(`${this.i18nPrefix}.btn.addPartTimeExperience`) }}
        </el-button>
      </div>
      <template v-for="(workExperience, index) in workExperienceList">
        <div class="workExperience-table" :class="!workExperience.showEdit && 'show-table'" :key="`workExperience_${index}`">
          <div class="head">
            <div class="title" @click="editorWorkExperience(workExperience, index)">{{ `${$t(`${i18nPrefix}.title.workExperience`)} ${index + 1}` }}</div>
            <div class="fold-btn" :class="workExperience.showEdit ? 'rotated-icon' : ''" @click="editorWorkExperience(workExperience, index)">
              <i class="iconfont icondown"></i>
            </div>
            <el-popconfirm
              :confirm-button-text="$t('common.btn.confirm')"
              :cancel-button-text="$t('common.btn.cancel')"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('common.message.confirmDelete')"
              @confirm="deleteWorkExperience(workExperience, index)"
            >
              <template #reference>
                <div class="delete-btn">
                  <i class="el-icon-close"></i>
                </div>
              </template>
            </el-popconfirm>
          </div>
          <div class="content">
            <el-table
              v-if="!workExperience.showEdit"
              row-key="_vid"
              :show-header="false"
              :data="[workExperience]"
              :row-class-name="getRowClass"
            >
              <el-table-column class-name="start-date" prop="startDate" :width="hasResumeView ? '90px' : '100px'" :formatter="formatDate"></el-table-column>
              <el-table-column prop="endDate" :width="hasResumeView ? '90px' : '100px'" :formatter="formatDate"></el-table-column>
              <el-table-column prop="companyName"></el-table-column>
              <el-table-column prop="jobTitle"></el-table-column>
            </el-table>
            <WorkExperience
              v-else
              class="workExperience-editor editor"
              :ref="`workEdit_${index}`"
              :workExperience="workExperience"
              :jobFamilyList="jobFamilyList"
              :countryList="countryList"
              :provinceList="workExperience.provinceList"
              :cityList="workExperience.cityList"
              :industryList="industryList"
              :currencyList="currencyList"
              :salaryList="salaryList"
              :isMiniResume="isMiniResume"
              :isCandidate="isCandidate"
              @country-change="handleCountryChange($event, workExperience)"
              @province-change="handleProvinceChange($event, workExperience)"
            />
          </div>
        </div>
      </template>
      <div v-if="pageSettings.showPartTimeExperienceTips" class="error-tips inter-tips">
        {{ $t(pageSettings.PartTimeExperienceTipsText) }}
      </div>
      <div class="add-btn-group">
        <el-button
          class="add-btn work-experience-btn"
          type="text"
          icon="iconfont iconjia"
          @click="handleAddWorkExperience"
        >
          {{ this.$t(`${this.i18nPrefix}.btn.addWorkExperience`) }}
        </el-button>
      </div>
      <div v-if="pageSettings.showWorkExperienceTips" class="error-tips work-tips">
        {{ $t(pageSettings.WorkExperienceTipsText) }}
      </div>
    </div>
    <RectLoading v-show="loading" class="loading"></RectLoading>
  </div>
</template>

<script>
import mixin from './mixin'
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import WorkExperience from '@/components/candidate/editor/workExperience.vue'
import moment from 'moment'
import RectLoading from '@/components/loading/rectLoading.vue'

let workVid = 0
let internshipVid = 0

export default {
  props: {
    setting: {
      type: Object,
      required: false
    },
    isMiniResume: {
      type: Boolean,
      default: false
    },
    hasResumeView: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixin],
  components: {
    WorkExperience,
    RectLoading
  },
  data () {
    const i18nPrefix = 'admin.application.candidate'
    return {
      hasForm: false,
      i18nPrefix,
      dataLoader: null,
      jobFamilyList: [],
      countryList: [],
      industryList: [],
      monthList: [],
      yearList: [],
      currencyList: [],
      salaryList: [],
      workExperienceList: [],
      partTimeExperienceList: [],
      pageSettings: {
        showWorkExperienceTips: false,
        WorkExperienceTipsText: '',
        showPartTimeExperienceTips: false,
        PartTimeExperienceTipsText: ''
      },
      stepData: {}
    }
  },
  computed: {
    requiredField () {
      // hr not need any check
      if (!this.isCandidate) {
        return []
      }
      const field = ['companyName', 'jobTitle', 'startDate']
      if (!this.isMiniResume) {
        field.push(...['jobFamily', 'industry', 'country', 'province', 'city'])
      }
      return field
    },
    isCandidate () {
      if (this.setting?.isCandidate) {
        return this.setting?.isCandidate
      }
      return false
    },
    workExperienceRequiredCount () {
      if (this.setting?.workCount) {
        return this.setting?.workCount
      }
      return 0
    },
    partTimeExperienceRequiredCount () {
      if (this.setting?.interCount) {
        return this.setting?.interCount
      }
      return 0
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('common', ['getCurrencyList']),
    ...mapActions('application', ['getIndustryList', 'getJobFamilyList', 'getSalaryList']),
    ...mapActions('worldLocation', ['getCountryList', 'getProvinceList', 'getCityList']),
    formatDate (row, column, cellValue, index) {
      if (cellValue) {
        return moment(cellValue).format('YYYY-MM')
      } else if (column.property === 'endDate' && row.startDate) {
        return this.$t('admin.application.candidate.label.tillNow')
      } else {
        return '-'
      }
    },
    formatSimpleJobInfo (infoItem) {
      const info = {
        ...infoItem,
        value: infoItem.id || infoItem.value
      }
      addI18nProperty(info, 'label', 'cn_name', 'name')
      return info
    },
    async loadData () {
      if (!this.dataLoader) {
        this.dataLoader = Promise.all([
          this.loadJobFamilyList(),
          this.loadCountryOrRegionList(),
          this.loadIndustryList(),
          this.loadCurrencyList(),
          this.loadSalaryList()
        ])
      }
      await this.dataLoader
    },
    async loadJobFamilyList () {
      const resp = await this.getJobFamilyList()
      if (resp) {
        this.jobFamilyList = _.map(resp.job_family_list, (item) => {
          item.value = item.id
          addI18nProperty(item, 'label', 'cn_name', 'en_name')
          return item
        })
      }
    },
    async loadCountryOrRegionList () {
      const resp = await this.getCountryList()
      if (resp) {
        this.countryList = _.map(resp.location_list, this.formatSimpleJobInfo)
      }
    },
    async loadProvinceOrStateList (countryId, workExperience) {
      this.provinceOrStateList = []
      if (countryId) {
        const params = {
          parentId: countryId
        }
        const resp = await this.getProvinceList(params)
        if (resp) {
          const provinceList = _.map(resp.location_list, this.formatSimpleJobInfo)
          workExperience.provinceList = provinceList
          workExperience.cityList.splice(0)
        }
      } else {
        workExperience.provinceList.splice(0)
      }
    },
    async loadCityOrTownList (provinceId, workExperience) {
      if (provinceId) {
        const params = {
          parentId: provinceId
        }
        const resp = await this.getCityList(params)
        if (resp) {
          const cityList = _.map(resp.location_list, this.formatSimpleJobInfo)
          workExperience.cityList = cityList
        }
      } else {
        workExperience.cityList.splice(0)
      }
    },
    async loadIndustryList () {
      const resp = await this.getIndustryList()
      if (resp) {
        this.industryList = _.map(resp.industry_list, this.formatSimpleJobInfo)
      }
    },
    async loadCurrencyList () {
      return this.getCurrencyList().then(resp => {
        if (!resp) {
          return []
        }
        const currencyList = _.map(resp, (item) => {
          return { id: item.id, label: `${item.name}(${item.value})`, value: item.name }
        })
        this.currencyList = currencyList
      })
    },
    async loadSalaryList () {
      const resp = await this.getSalaryList()
      if (resp) {
        this.salaryList = _.map(resp.salary_list, this.formatSimpleJobInfo)
      }
    },
    handleCountryChange (countryId, workExperience) {
      this.loadProvinceOrStateList(countryId, workExperience)
    },
    handleProvinceChange (provinceId, workExperience) {
      this.loadCityOrTownList(provinceId, workExperience)
    },
    async editorPartTime (rowData, index) {
      await this.loadData()
      const showEdit = rowData.showEdit
      if (showEdit) {
        const data = await this.$refs[`partTimeEdit_${index}`][0]?.submit()
        if (!data) {
          return
        }
        rowData.valid = true
        _.merge(rowData, data)
      }
      rowData.showEdit = !showEdit
    },
    deletePartTime (rowData, index) {
      this.partTimeExperienceList.splice(index, 1)
    },
    async editorWorkExperience (rowData, index) {
      await this.loadData()
      const showEdit = rowData.showEdit
      if (showEdit) {
        const data = await this.$refs[`workEdit_${index}`][0]?.submit()
        if (!data) {
          return
        }
        rowData.valid = true
        _.merge(rowData, data)
      }
      rowData.showEdit = !showEdit
    },
    deleteWorkExperience (rowData, index) {
      this.workExperienceList.splice(index, 1)
    },
    async handleAddPartTime () {
      await this.loadData()
      const workInfo = this.initFormData()
      workInfo._vid = ++internshipVid
      workInfo.valid = false
      this.partTimeExperienceList.push(workInfo)
    },
    async handleAddWorkExperience () {
      await this.loadData()
      const workInfo = this.initFormData()
      workInfo._vid = ++workVid
      workInfo.valid = false
      this.workExperienceList.push(workInfo)
    },
    initFormData () {
      return {
        provinceList: [],
        cityList: [],
        showEdit: true
      }
    },
    async setStepDataToCandidateInfo () {
      const candidateInfo = this.candidateInfo
      this.$set(candidateInfo, 'workExperienceInfo', {
        partTimeExperience: _.map(this.partTimeExperienceList, item => {
          const info = { ...item }
          _.omit(info, [
            '_vid',
            'valid',
            'provinceList',
            'cityList'
          ])
          return info
        }),
        workExperience: _.map(this.workExperienceList, item => {
          const info = { ...item }
          _.omit(info, [
            '_vid',
            'valid',
            'provinceList',
            'cityList'
          ])
          return info
        })
      })
    },
    async getStepData () {
      const workExperienceInfo = this.candidateInfo.workExperienceInfo
      this.partTimeExperienceList = _.map(workExperienceInfo?.partTimeExperience, (item, index) => {
        return {
          ...item,
          _vid: index + 1,
          showEdit: _.isBoolean(item.showEdit) ? item.showEdit : this.showEdit,
          provinceList: [],
          cityList: [],
          jobFamily: parseInt(item.jobFamily) || null
        }
      })
      internshipVid = this.partTimeExperienceList.length
      this.workExperienceList = _.map(workExperienceInfo?.workExperience, (item, index) => {
        return {
          ...item,
          _vid: index + 1,
          provinceList: [],
          cityList: [],
          jobFamily: parseInt(item.jobFamily) || null,
          showEdit: _.isBoolean(item.showEdit) ? item.showEdit : this.showEdit
        }
      })
      workVid = this.workExperienceList.length
    },
    async customValidate () {
      let length = this.workExperienceList.length
      let isValid = true
      await Promise.all(_.times(length, async index => {
        const workRef = this.$refs[`workEdit_${index}`]
        if (workRef && workRef.length > 0) {
          const data = await workRef[0].submit()
          if (data) {
            _.merge(this.workExperienceList[index], data)
          } else {
            isValid = false
          }
        }
      }))
      length = this.partTimeExperienceList.length
      await Promise.all(_.times(length, async index => {
        const partTimeRef = this.$refs[`partTimeEdit_${index}`]
        if (partTimeRef && partTimeRef.length > 0) {
          const data = await partTimeRef[0].submit()
          if (data) {
            _.merge(this.partTimeExperienceList[index], data)
          } else {
            isValid = false
          }
        }
      }))
      return isValid
    },
    async validate () {
      let isValid = true
      if (this.hasForm) {
        isValid = await this.$refs.form.submit()
      }
      if (isValid) {
        isValid = await this.customValidate()
      }
      const workValid = this.checkExperienceList(this.workExperienceList)
      if (!workValid) {
        this.pageSettings.showWorkExperienceTips = true
        this.pageSettings.WorkExperienceTipsText = `${this.i18nPrefix}.message.fieldRequired`
      }
      const partTimeworkValid = this.checkExperienceList(this.partTimeExperienceList)
      if (!partTimeworkValid) {
        this.pageSettings.showPartTimeExperienceTips = true
        this.pageSettings.PartTimeExperienceTipsText = `${this.i18nPrefix}.message.fieldRequired`
      }

      isValid = workValid && partTimeworkValid
      if (this.workExperienceList.length < this.workExperienceRequiredCount || this.partTimeExperienceList.length < this.partTimeExperienceRequiredCount) {
        this.pageSettings.showWorkExperienceTips = this.workExperienceList.length < this.workExperienceRequiredCount
        this.pageSettings.showPartTimeExperienceTips = this.partTimeExperienceList.length < this.partTimeExperienceRequiredCount
        this.pageSettings.WorkExperienceTipsText = `${this.i18nPrefix}.message.workCountRequired`
        this.pageSettings.PartTimeExperienceTipsText = `${this.i18nPrefix}.message.interCountRequired`
        isValid = false
      }
      return Boolean(isValid)
    },
    checkExperienceList (ExperienceList) {
      let isValid = true
      if (!ExperienceList || ExperienceList.length === 0) {
        return isValid
      }
      _.forEach(ExperienceList, item => {
        let valid = true
        _.forEach(this.requiredField, fieldName => {
          if (_.isNil(item[fieldName]) || item[fieldName] === '') {
            valid = false
            isValid = false
          }
        })
        this.$set(item, 'valid', valid)
      })
      return isValid
    },
    getRowClass ({ row }) {
      if (row && !row.valid) {
        return 'red'
      }
      return ''
    }
  },
  watch: {
    workExperienceList (val) {
      this.checkExperienceList(this.workExperienceList)
      if (this.workExperienceList.length >= this.workExperienceRequiredCount) {
        this.pageSettings.showWorkExperienceTips = false
        this.pageSettings.WorkExperienceTipsText = `${this.i18nPrefix}.message.fieldRequired`
      }
    },
    partTimeExperienceList (val) {
      this.checkExperienceList(this.partTimeExperienceList)
      if (this.partTimeExperienceList.length >= this.partTimeExperienceRequiredCount) {
        this.pageSettings.showPartTimeExperienceTips = false
        this.pageSettings.PartTimeExperienceTipsText = `${this.i18nPrefix}.message.fieldRequired`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.work-experience-dialog {
  position: relative;

  .workExperience-list-editor {
    padding: 0 20px;

    .workExperience-list {
      margin-top: 20px;
      margin-bottom: 40px;

      .list-item {
        padding: 5px 10px;
        border: 1px solid #e7e7e7;
        background: #f1f1f1;

        &:not(:first-child) {
          margin-top: 10px;
        }

        &.ghost {
          opacity: 0.5;
          background-color: #cecece;
        }

        .item-title {
          display: flex;
          line-height: 16px;

          .item-icon {
            line-height: 20px;

            .icon {
              display: inline-block;
              width: 14px;
              height: 14px;
              background-repeat: no-repeat;
              background-size: contain;
            }

            .text-icon {
              background-image: url(~@/assets/image/openQuestion/text.png);
            }

            .select-icon {
              background-image: url(~@/assets/image/openQuestion/select.png);
            }

            .checkbox-icon {
              background-image: url(~@/assets/image/openQuestion/checkbox.png);
            }

            .attachment-icon {
              background-image: url(~@/assets/image/openQuestion/attachment.png);
            }

            .video-icon {
              background-image: url(~@/assets/image/openQuestion/video.png);
            }
          }

          .item-name {
            flex: 1;
            margin-left: 10px;
            color: #3b3b3b;
          }

          .item-btn-group {
            display: flex;
            color: #0096cc;
            align-items: center;

            .item-btn {
              cursor: pointer;

              i {
                font-size: 18px;
              }

              &:not(:first-child) {
                margin-left: 10px;
              }
            }

            .drag-btn {
              cursor: grab;
            }

            .visibility-btn {
              color: inherit;
              font-size: 12px;

              .btn-inner-container {
                .btn-label {
                  vertical-align: middle;
                }

                .btn-icon {
                  font-size: 14px;
                  vertical-align: middle;
                }
              }
            }
          }
        }
        .item-options-container {
          color: #676767;

          .option-list {
            padding-left: 15px;

            .option-item {
              padding: 3px 0;

              &::before {
                content: '-';
                margin-right: 10px;
              }

              &.knockout {
                color: #F56C6C;
              }

              .knockout-tag {
                height: auto;
                margin: 0 10px;
                padding: 1px 5px;
                border-radius: 15px;
                line-height: normal;
              }
            }
          }
        }
      }
    }

    .add-btn-group {
      .add-btn {
        display: inline-block;
        width: 100%;
        margin: 15px auto 0;
        padding: 13px 0;
        border: 1px dashed #0096cc;
        border-radius: 0;
        font-size: 14px;

        ::v-deep .iconfont {
          font-size: 14px;
        }
      }

      .part-time-btn {
        margin-top: 24px;
        margin-bottom: 24px;
      }

      .work-experience-btn {
        margin-top: 24px;
      }
    }

    .workExperience-table {
      border: 1px solid #e4e7ed;
      margin-bottom: 8px;

      .head {
        display: flex;
        align-items: center;
        height: 40px;
        line-height: 40px;
        padding: 0 25px;
        border-bottom: 1px solid #dcdfe6;

        .title {
          flex: 1;
          display: inline-block;
          color: #606266;
          font-size: 15px;
          cursor: pointer;
        }

        .fold-btn {
          display: inline-block;
          transition: transform 0.3s;

          &:hover {
            cursor: pointer;
          }
        }

        .rotated-icon {
          transform: rotate(180deg);
        }

        .delete-btn {
          position: relative;
          right: -10px;
          display: inline-block;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .content {
        ::v-deep {
          .start-date {
            .cell {
              padding-left: 25px;
            }
          }
        }

        .workExperience-editor {
          margin: 25px 70px 0;
        }
      }

      ::v-deep {
        .el-table__row {
          &.red {
            color: #ff0000;
          }
          background-color: #f7f7f7;

          .el-table__cell {
            .cell {
              word-break: break-word;
            }
          }
        }
      }
    }

    .show-table {
      border-bottom: 0;
    }

    ::v-deep {
      .el-dialog {
        width: 63vw;
        background-color: #f7f7f7;
      }
      .el-dialog__footer{
        padding: 10px 55px 20px;
      }
    }

    .error-tips {
      padding: 20px 0;
      color: #ff0000;
      text-align: right;
    }

    .editor-dialog {
      .form-container {
        width: 80%;
        margin: auto;
      }

      .editor-footer {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .loading {
    position: absolute;
  }
}

.has-resume-view {
  .workExperience-list-editor {
    width: 90%;
    margin-left: 34px;

    .workExperience-table {
      .el-table {
        font-size: 12px;

        .el-button {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
